import React from 'react';
import { Drawer, Tag, Tooltip, Button, Spin } from 'antd';
import {
  CopyFilled,
  FilePdfOutlined,
  FileWordOutlined,
  FileOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import './index.css';

const EmailDrawer = ({
  open,
  onClose,
  emailLoading,
  emailError,
  emails,
  selectedEmail,
  setSelectedEmail,
}) => (
  <Drawer
    rootClassName="email-drawer"
    title="Emails"
    placement="right"
    onClose={onClose}
    open={open}
    width='88%'
    destroyOnClose
  >
    {emailLoading ? (
      <div className="email-loading">
        <Spin tip="Loading" size="large" />
      </div>
    ) : emailError ? (
      <div className="email-empty">{emailError}</div>
    ) : !emails || emails.length === 0 ? (
      <div className="email-empty">No emails</div>
    ) : (
      <div className="email-pane">
        <div className="email-list">
          {emails.map(item => (
            <div
              key={item.email_id}
              className={`email-item ${selectedEmail?.email_id === item.email_id ? 'active' : ''}`}
              onClick={() => setSelectedEmail(item)}
            >
              <div className="email-item-header">
                <span className="email-item-sender">{item.from_email}</span>
              </div>
              <div className="email-item-subject">
                {item.subject}
                <span className="email-item-time">
                  {new Date(item.date).toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="email-detail">
          {selectedEmail ? (
            <>
              <div className="email-headers">
                <div className="email-header-item">
                  <div className="email-header-item-label">Sender</div>
                  <div className='email-header-item-div'>
                    <Tag className="email-header-item-div-tag" color='blue'>
                      {selectedEmail.from_email || 'default'}
                    </Tag>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => navigator.clipboard.writeText(selectedEmail.from_email || 'default')}
                    >
                      <CopyFilled />
                    </Button>
                  </div>
                </div>
                <div className="email-header-item">
                  <div className="email-header-item-label">Recipient</div>
                  <div className='email-header-item-div'>
                    <Tag className="email-header-item-div-tag" color='blue'>
                      {selectedEmail.to_email || 'default'}
                    </Tag>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => navigator.clipboard.writeText(selectedEmail.to_email || 'default')}
                    >
                      <CopyFilled />
                    </Button>
                  </div>
                </div>
                <div className="email-header-item">
                  <div className="email-header-item-label">Time</div>
                  <div className='email-header-item-div'>
                    <Tag className="email-header-item-div-tag" color='blue'>
                      {new Date(selectedEmail.date).toLocaleString() || 'default'}
                    </Tag>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => navigator.clipboard.writeText(new Date(selectedEmail.date).toLocaleString() || 'default')}
                    >
                      <CopyFilled />
                    </Button>
                  </div>
                </div>
                <div className="email-header-item">
                  <div className="email-header-item-label">Subject</div>
                  <div className='email-header-item-div'>
                    <Tag className="email-header-item-div-tag" color='blue'>
                      {selectedEmail.subject || 'default'}
                    </Tag>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => navigator.clipboard.writeText(selectedEmail.subject || 'default')}
                    >
                      <CopyFilled />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="email-body">
                {selectedEmail.archived_flag ? (
                  <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999', fontSize: 14 }}>
                    <span style={{ fontSize: 32, display: 'block', marginBottom: 12 }}>📦</span>
                    该历史邮件已归档
                  </div>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: selectedEmail.html_content || selectedEmail.content || "No content for now"
                    }}
                  />
                )}
              </div>
              {!selectedEmail.archived_flag && selectedEmail?.attachments?.length > 0 && (
                <div className="email-attachments">
                  {selectedEmail.attachments.map((item, index) => {
                    const fileType = item.file_name.split('.').pop().toLowerCase();
                    let icon;
                    if (fileType === 'pdf') {
                      icon = <FilePdfOutlined style={{ color: 'red', fontSize: '24px' }} />;
                    } else if (fileType === 'doc' || fileType === 'docx') {
                      icon = <FileWordOutlined style={{ color: 'blue', fontSize: '24px' }} />;
                    } else {
                      icon = <FileOutlined style={{ color: 'purple', fontSize: '24px' }} />;
                    }
                    return (
                      <Tooltip key={index} title={item.file_name}>
                        <div className="email-attachment-item">
                          {icon}
                          <div className="attachment-size">{Math.round(item.size_kb)}KB</div>
                          <DownloadOutlined
                            className="attachment-download"
                            onClick={() => {
                              const link = document.createElement('a');
                              link.href = item.oss_url;
                              link.download = item.file_name;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          />
                        </div>
                      </Tooltip>
                    );
                  })}
                </div>
              )}
            </>
          ) : (
            <div className="email-empty">Please select an email</div>
          )}
        </div>
      </div>
    )}
  </Drawer>
);

export default EmailDrawer;
